import React, { Component } from 'react';
import './styles.css';

// Images
import logo from '../../images/menu/logo_reservando_word.png';
import menu_close from '../../images/menu/menu_close.png';
import menu_open from '../../images/menu/menu_open.png';

class MainMenu extends Component {
    state = {
        navClassName: '',
        isMenuOpened: false,
        iconAvailable: 'iconColor'
    }
    
    onMenuClick = () => {
        if(this.state.isMenuOpened) {
            this.setState({ isMenuOpened: false });
        } else {
            this.setState({ isMenuOpened: true });
        }
    }

    hideMenu = () => {
        this.setState({ isMenuOpened: false });
    }
    
    render() {
        return (
            <div className="mainMenuCont">
                <nav className="bar">
                    <div className="logo">
                        <img src={logo} alt="logo"/>
                    </div>
                    <ul className="listCont">
                        <li onClick={this.hideMenu}><span className="navLink" onClick={this.props.onLoginClick}>¿Tenés un restaurante?</span></li>
                    </ul>
                    <div className="listCompactCont">
                        {
                            this.state.iconAvailable === 'iconColor' ?
                                this.state.isMenuOpened ?
                                    <img onClick={this.onMenuClick} className="iconMenu" alt="menu" src={menu_open} />
                                    :
                                    <img onClick={this.onMenuClick} className="iconMenu" alt="menu" src={menu_close} />
                                :
                                this.state.isMenuOpened ?
                                    <img onClick={this.onMenuClick} className="iconMenu" alt="menu" src={menu_open} />
                                    :
                                    <img onClick={this.onMenuClick} className="iconMenu" alt="menu" src={menu_close} />
                        }
                    </div>
                </nav>
                {
                    this.state.isMenuOpened &&
                        <div className="barlistMenuCont">
                            <ul className="">
                                <li onClick={this.hideMenu}><span className="navLink" onClick={this.props.onLoginClick}>¿Tenés un restaurante?</span></li>
                            </ul>
                        </div>
                }
            </div>
        );
    }
}

MainMenu.propTypes = {

};

export default MainMenu;